<template>
  <nt-auth-template>
    <v-row dense align="center" justify="center">
      <v-col cols="12" sm="8" md="6" lg="4">
        <v-btn :to="{ name: 'auth.firstAccess.verification' }" block large color="accent" dark class="mb-5">Primeiro acesso?</v-btn>
        <v-card color="loginBackground">
          <v-card-text class="text-center">
            <img class="my-3" :src="info.app_logo"/>
            <h3 class="text-h5 mt-4 mb-0">Login</h3>
          </v-card-text>
          <v-card-text>
            <v-row dense>
              <v-col cols="12">
                <v-form @submit.prevent="login()" id="login" method="post">
                  <v-text-field
                    name="email"
                    label="Email"
                    v-model="user.email"
                    required
                    prepend-icon="mdi-account"
                    type="email"
                    :error="error.error"
                    :error-messages="error.messages"
                    :autofocus="focusUsernameInput"
                    color="loginFont"/>
                  <v-text-field
                    name="password"
                    label="Senha"
                    v-model="user.password"
                    required
                    prepend-icon="mdi-key"
                    :append-icon="passVisibility ? 'mdi-eye-off' : 'mdi-eye'"
                    @click:append="passVisibility = !passVisibility"
                    :type="passVisibility ? 'text' : 'password'"
                    :autofocus="!focusUsernameInput"
                    color="loginFont"/>
                </v-form>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-btn text exact :to="{ name: 'auth.resetPassword' }">Esqueci minha senha!</v-btn>
            <v-spacer/>
            <v-btn exact type="submit" form="login" color="loginButton">Entrar</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </nt-auth-template>
</template>

<script>
import store from '@/store'
import { mapGetters } from 'vuex'
import Storage from '@/services/Storage'
import NtAuthTemplate from '@/components/Utils/NtAuthTemplate'

const localStorage = new Storage(window.localStorage)

export default {
  components: {
    NtAuthTemplate
  },
  mounted () {
    if (this.isAuthenticated) {
      this.$router.push({ name: 'ambienteAluno.dashboard' })
    }
  },
  data () {
    return {
      user: {
        email: localStorage.get('login_username', ''),
        password: ''
      },
      error: {
        error: false,
        messages: []
      },
      passVisibility: false
    }
  },
  methods: {
    login () {
      this.error.error = false
      this.error.messages = []
      store.dispatch('App/login', this.user)
        .then((response) => {
          localStorage.set('login_username', this.user.email)
          this.$router.push(this.nextLogin)
        }).catch((responseError) => {
          this.error.error = true
          this.user.password = ''
          if (responseError.status === 401) {
            this.error.messages.push('Credenciais inválidas. Email ou senha incorretos.')
          } else if (responseError.status === 422) {
            this.error.messages = responseError.data.errors.email[0]
          } else {
            this.error.messages.push('Login falhou')
          }
        })
    }
  },
  computed: {
    ...mapGetters({
      isAuthenticated: 'App/isAuthenticated',
      nextLogin: 'App/nextLogin',
      info: ['App/info']
    }),
    focusUsernameInput () {
      return this.user.email === ''
    }
  }
}
</script>
